import { useAlert } from '../../../../contexts'
import { validationSchema } from '../validation'
import { CalculateMembershipFeeInput } from '../types'
import { Form, Formik, FormikHelpers } from 'formik'
import { usePaymentInfo } from '../contexts'
import { CalculateMembershipFeeFormContent } from './calculate-membership-fee-form-content'
import { MembershipFeesQueryType } from '../../../../types'
import { UserInfo } from '../../../../utils/classes/graphql'
import { AlertSeverity, SubmitAlert } from '../../../../components'
import { Grid } from '@mui/material'
import { getAccrualBaseOrDefaultProps } from '../utils'

interface CalculateMembershipFeeFormProps {
  membershipFees: MembershipFeesQueryType
  user: UserInfo
}

export const CalculateMembershipFeeForm = ({
  membershipFees,
  user
}: CalculateMembershipFeeFormProps) => {
  const { alertType, setAlertType } = useAlert()

  const { updatePaymentInfo } = usePaymentInfo()

  const { accrualBasesThisYear, bankAccounts } = membershipFees

  const { accrualBaseAmount, accrualBaseType } =
    getAccrualBaseOrDefaultProps(accrualBasesThisYear)

  const initialValues: CalculateMembershipFeeInput = {
    startDate: '',
    endDate: '',
    amount: accrualBaseAmount || '',
    grossSalary: '',
    type: accrualBaseType
  }

  const handleSubmit = (
    values: CalculateMembershipFeeInput,
    { setSubmitting }: FormikHelpers<CalculateMembershipFeeInput>
  ) => {
    const error = updatePaymentInfo(bankAccounts, user, values)
    if (error) {
      setAlertType({
        severity: AlertSeverity.ERROR,
        message: error
      })
    } else {
      setAlertType(undefined)
    }
    setSubmitting(false)
  }

  return (
    <Grid container spacing={2}>
      <Grid item md={12} xs={12}>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          validateOnChange={false}
          validateOnBlur={false}
          enableReinitialize={true}
          onSubmit={handleSubmit}
        >
          {(formik) => {
            return (
              <Form noValidate={true} onSubmit={formik.handleSubmit}>
                <CalculateMembershipFeeFormContent
                  defaultAccrualBaseAmount={accrualBaseAmount}
                  defaultAccrualBaseType={accrualBaseType}
                />
              </Form>
            )
          }}
        </Formik>
      </Grid>
      {alertType?.severity && (
        <Grid item md={12} xs={12}>
          <SubmitAlert alertType={alertType} />
        </Grid>
      )}
    </Grid>
  )
}
